import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { DraggableCourseSlot, Droppable, ResizableCourseSlot, } from 'components/custom';
import { getTextColor } from 'utils/color';
import { FIRST_DAY_OF_THE_WEEK, LAST_DAY_OF_THE_WEEK, HOURS_PER_DAY, } from 'utils/date';
import { DragAndDropOperationNames } from 'utils/drag-and-drop';
const CourseCell = ({ course, day, hour, onDeleteCourseSuccess, onPlanCourseSuccess, onHourLengthChange, emptyNextCell, }) => {
    const textColor = getTextColor(course?.color);
    const onSizeChange = (diff) => {
        if (course) {
            onHourLengthChange?.(diff, course);
        }
    };
    return (_jsxs(Box, { role: "gridcell", title: course?.name, sx: {
            background: course?.color ?? 'none',
            border: 'solid 1px',
            borderColor: 'secondary.light',
            display: 'grid',
            gridColumn: day + 1,
            gridRow: `${hour + 1} / span ${course?.lengthHours ?? 1}`,
            overflow: 'hidden',
            placeItems: 'center',
            textAlign: 'center',
        }, children: [course && onPlanCourseSuccess && (_jsx(ResizableCourseSlot, { hoursLength: course.lengthHours, iconColor: textColor, onSizeChange: onSizeChange, emptyNextCell: emptyNextCell, children: _jsx(DraggableCourseSlot, { courseWithSlots: course, onPlanCourseSuccess: onPlanCourseSuccess, onDeleteCourseSuccess: onDeleteCourseSuccess }) })), !course && (_jsx(Droppable, { droppableId: `${day}-${hour}`, operationName: DragAndDropOperationNames.PLAN_COURSE, outlineColor: "primary", outlinePosition: "inside" }))] }));
};
const CoursePlannerCells = ({ data, onPlanCourseSuccess, onDeleteCourseSuccess, onHourLengthChange, }) => {
    const result = [];
    for (let day = FIRST_DAY_OF_THE_WEEK; day <= LAST_DAY_OF_THE_WEEK; day++) {
        for (let hour = 1; hour <= HOURS_PER_DAY;) {
            const course = data.find((c) => c.weekday === day && c.hourInDay === hour);
            const emptyNextCell = hour < HOURS_PER_DAY
                ? !data.find((currentCourse) => currentCourse.weekday === day &&
                    currentCourse.hourInDay === hour + 1)
                : false;
            result.push(_jsx(CourseCell, { course: course, day: day, hour: hour, onPlanCourseSuccess: onPlanCourseSuccess, onDeleteCourseSuccess: onDeleteCourseSuccess, onHourLengthChange: onHourLengthChange, emptyNextCell: emptyNextCell }, `${day}-${hour}`));
            hour += course?.lengthHours ?? 1;
        }
    }
    return result;
};
export default CoursePlannerCells;
